import { useState } from 'react';
import {
  Box,
  Card,
  Title,
  Radio,
  Link,
  Icon,
  Text,
} from '@nimbus-ds/components';
import { PlusCircleIcon } from '@nimbus-ds/icons';
import { FormField } from '@nimbus-ds/patterns';
import ModalAside from 'App/components/lab/ModalAside';
import { HeaderTop, CancelAndSaveButtons } from 'commons/components';
import { useModal } from 'commons/hooks';
import { useTranslationAccount } from 'domains/Account/hooks';
import { SelectedProductInterface } from 'domains/Catalog/Products/components';
import SelectedListProducts from '../SelectedListProducts';
import SelectProductsModal from '../SelectProductsModal';
import TaxRateInput from '../TaxRateInput';

interface TaxExceptionsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

function TaxExceptionsModal({ isOpen, onClose }: TaxExceptionsModalProps) {
  const t = useTranslationAccount('businessDataPage.taxesWithExceptions.modal');
  const [isShowModal, openModal, closeModal] = useModal();
  const headerNavigation = { onClick: onClose };

  const [selectedProducts, setSelectedProducts] = useState<
    SelectedProductInterface[]
  >([]);

  const handleOnChange = (selected: SelectedProductInterface[]) => {
    setSelectedProducts(selected);
  };

  const handleRemoveProduct = (productId: string) => {
    handleOnChange(
      selectedProducts.filter((product) => product.id !== productId),
    );
  };

  return (
    <ModalAside
      isOpen={isOpen}
      onDidDismiss={onClose}
      headerTop={<HeaderTop navigation={headerNavigation} />}
      headerContent={<Title fontSize="h2">{t('title')} </Title>}
    >
      <Box display="flex" flexDirection="column" gap="4">
        <Card>
          <Card.Header>
            <Title as="h4">{t('name')}</Title>
          </Card.Header>
          <Card.Body>
            <Box display="flex" flexDirection="column" gap="2">
              <FormField.Input
                name="name"
                onChange={(e) => console.log(e.target.value)}
              />
              <Text>{t('helpTextName')}</Text>
            </Box>
          </Card.Body>
        </Card>
        <Card>
          <Card.Header>
            <Title as="h4">{t('alicuotaTitle')}</Title>
          </Card.Header>
          <Card.Body>
            <TaxRateInput value={10} />
          </Card.Body>
        </Card>
        <Card>
          <Card.Header>
            <Title as="h4">{t('applyTo')}</Title>
          </Card.Header>
          <Card.Body>
            <Box display="flex" flexDirection="column" gap="3">
              <Radio
                as="button"
                name="my-radio"
                label={t('buttonProducts')}
                checked
              />
              {selectedProducts.length > 0 ? (
                <SelectedListProducts
                  selectedProducts={selectedProducts}
                  onRemoveProduct={handleRemoveProduct}
                  onOpenModal={openModal}
                />
              ) : (
                <Link
                  appearance="primary"
                  as="button"
                  textDecoration="none"
                  onClick={openModal}
                >
                  <Icon color="currentColor" source={<PlusCircleIcon />} />
                  {t('selectProducts')}
                </Link>
              )}
            </Box>
          </Card.Body>
        </Card>
      </Box>
      <CancelAndSaveButtons
        isLoading={false}
        onCancel={onClose}
        onSave={() => console.log('save')}
        isDisabled={false}
      />
      {isShowModal && (
        <SelectProductsModal
          selectedProducts={selectedProducts}
          onChange={handleOnChange}
          isShow={isShowModal}
          onClose={closeModal}
        />
      )}
    </ModalAside>
  );
}

export default TaxExceptionsModal;
